import { useAuth } from '../context/AuthContext';
import { ApplicationLauncher } from '../components/ApplicationLauncher';
import { MorningBrief } from '../components/MorningBrief';

export function HomePage() {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0] || 'there';

  return (
    <div className="h-full overflow-y-auto p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        {/* Greeting */}
        <div className="mb-4 sm:mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">
            Good {getTimeOfDay()}, {firstName}
          </h1>
          <p className="text-gray-500 mt-1">
            {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>

        {/* Morning Brief */}
        <div className="mb-6">
          <MorningBrief />
        </div>

        {/* Application Launcher */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <ApplicationLauncher />
        </div>
      </div>
    </div>
  );
}

function getTimeOfDay(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
}
